var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MemberLayout',{attrs:{"disabledPadding":true}},[_c('div',[(_vm.isLoaded)?_c('div',[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.getPaymentPgaeURL,"width":"100%"}})]):_vm._e()])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }